<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                        <h2 class="mb-0">Prints</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <router-link to="/create-print" class="btn btn-primary px-5 w-100 text-nowrap">New</router-link>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">
                            <div class="card" id="table">
                                <div class="card-header">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <form>
                                                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                                                    <span class="input-group-text search"><MagnifyIcon /></span>
                                                    <input class="form-control list-search" v-model="filtro" type="buscar" placeholder="Search..">
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-sm fs--1 mb-0">
                                        <thead>
                                        <tr>
                                            <th class="sort border-top">Image</th>
                                            <th class="sort border-top">Title</th>
                                            <th class="sort border-top">Slug</th>
                                            <th class="sort border-top">Price</th>
                                            <th class="sort border-top">Pre-sale</th>
                                            <th class="sort text-end align-middle pe-0 border-top" scope="col">
                                                <span class="nav-link-icon"><span data-feather="cog"></span></span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(print,x) in filteredPrints" :key="x">
                                                <td class="align-middle">
                                                    <img v-if="print.featuredImg" :src="thumb(print.featuredImg)" :alt="print.title" class="rounded" style="width:56px;height:56px;object-fit:cover" loading="lazy" />
                                                </td>
                                                <td class="item-nombre align-middle">{{print.title}}</td>
                                                <td class="item-nombre align-middle">{{print.slug}}</td>
                                                <td class="item-nombre align-middle">$ {{print.price}}</td>
                                                <td class="item-nombre align-middle">$ {{print.presale}}</td>
                                                <td class="align-middle white-space-nowrap text-end pe-0">
                                                    <div class="font-sans-serif btn-reveal-trigger position-static">
                                                        <button class="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs--2" type="button" data-bs-toggle="dropdown" data-boundary="window" aria-haspopup="true" aria-expanded="false" data-bs-reference="parent">
                                                            <svg class="svg-inline--fa fa-ellipsis fs--2" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ellipsis" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z"></path></svg>
                                                        </button>
                                                        <div class="dropdown-menu dropdown-menu-end py-2">
                                                            <router-link class="dropdown-item" :to="'/print/'+print.id">Open</router-link>
                                                            <div class="dropdown-divider"></div>
                                                            <a href="#" class="dropdown-item text-danger" @click.prevent="borrar(print)">Delete</a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>
<script>
import SideBar from '@/components/SideBarNav.vue'
import TopBar from '@/components/TopBarNav.vue'
import axios from 'axios'
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';
export default {
    name: 'printsView',
    components:{SideBar,TopBar,MagnifyIcon},
    data(){
        return{
            prints:[],
            filtro:''
        }
    },
    created(){
        this.getData()
    },
    computed:{
        filteredPrints(){
            if(this.filtro == '') return this.prints
            const f = this.filtro.toLowerCase().trim()
            return this.prints.filter((e)=>{
                return (e.title || '').toLowerCase().includes(f) ||
                       (e.slug || '').toLowerCase().includes(f)
            })
        }
    },
    methods:{
        // Serve a cached 200px thumbnail instead of the full-size original.
        thumb(path){
            return path ? this.$url + '/thumb/200/' + path : ''
        },
        getData(){
            axios.get(this.$url+'/printsadmin',{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                this.prints = res.data
            }).catch((err)=>{
                console.log(err)
            })
        },
        borrar(data){
            if(!confirm('Delete this print?')) return
            axios.post(this.$url+'/prints/delete/'+data.id,{},{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then(()=>{
                this.prints = this.prints.filter(e=>e.id != data.id)
            }).catch((err)=>{
                console.log(err)
            })
        }
    }
}
</script>
